<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
	>
		<g clip-path="url(#clip0_10150_8901)">
			<path
				d="M8.6463 0.10575C8.89578 -0.0586988 9.23437 -0.0307905 9.45391 0.188758L17.8113 8.5452L17.8934 8.64677C18.0579 8.89622 18.0308 9.23477 17.8113 9.45438C17.5917 9.67404 17.2523 9.7021 17.0027 9.53739L16.9022 9.45438L8.99884 1.55106L1.09649 9.45438L0.995906 9.53739C0.746465 9.70185 0.40786 9.67382 0.188289 9.45438C-0.0627628 9.20333 -0.0627628 8.79625 0.188289 8.5452L8.54473 0.188758L8.6463 0.10575Z"
				fill="white"
			/>
			<path
				d="M2.57227 10.9286C2.57227 10.5735 2.8598 10.286 3.21484 10.286C3.56988 10.286 3.85742 10.5735 3.85742 10.9286V16.7147H14.1436V10.9286C14.1436 10.5736 14.4312 10.2861 14.7861 10.286C15.1412 10.286 15.4287 10.5735 15.4287 10.9286V17.3573C15.4286 17.7123 15.1411 17.9999 14.7861 17.9999H3.21484C2.85985 17.9999 2.57234 17.7123 2.57227 17.3573V10.9286Z"
				fill="white"
			/>
		</g>
		<defs>
			<clipPath id="clip0_10150_8901">
				<rect width="18" height="18" fill="white" />
			</clipPath>
		</defs>
	</svg>
</template>
